// ExportButton.js

import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { MdOutlineFileDownload } from "react-icons/md";
import { CiExport } from "react-icons/ci";
import { RiDownload2Fill } from "react-icons/ri";
import { CgExport } from "react-icons/cg";

const ExportButton = ({ dataArray,dataArray2 }) => {
  const crud=sessionStorage.getItem("crud_permission")
  const exportToExcel = () => {
    console.log(dataArray,"dataarrardataarray")
    if (dataArray?.length <= 0) {
      alert("No data to export!");
      return;
    }

    const workbook = XLSX?.utils?.book_new();
    const worksheet = XLSX?.utils?.json_to_sheet(dataArray);
    XLSX?.utils?.book_append_sheet(workbook, worksheet, "Sheet 1");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const excelBlob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
    saveAs(excelBlob, "exported_data.xlsx");
  };

  const exportToExcel2 = () => {
    console.log(dataArray2,"dataarrardataarray")
    if (dataArray2?.length <= 0) {
      alert("No data to export!");
      return;
    }

  const flattenedData = dataArray2.map(entry => ({
    // Parent ticket info
      login_user_id: entry.login_user_id,
      login_user_email: entry.login_user_email,
      login_user_mobile: entry.login_user_mobile,
      ticket_no: entry.ticket_no,
      pnr_no: entry.pnr_no,
      source_name: entry.source_name,
      pickup_point_name: entry.pickup_point_name,
      depature_date: entry.depature_date,
      depature_time: entry.depature_time,
      destination_name: entry.destination_name,
      droping_point_name: entry.droping_point_name,
      arrival_date: entry.arrival_date,
      arraival_time: entry.arraival_time,
      operator_name: entry.operator_name,
      partialcancellation: entry.partialcancellation,
      cancel_date_time: entry.cancel_date_time,
      total_fare: entry.total_fare,
      refund_amt: entry.refund_amt,
      base_fare: entry.base_fare,
      gst: entry.gst,
      tbs_deal: entry.tbs_deal,
      tbs_discount: entry.tbs_discount,
      refund_percent: entry.refund_percent,
      device_type: entry.device_type,
      abhibus_refund: entry.abhibus_refund,
      offer_code: entry.offer_code,
      status_type: entry.status_type,
      payment_id: entry.payment_id,

  // Passenger details as JSON string
  passenger_details: JSON.stringify(entry.passenger_details)
}));
 // Use separator if multiple passengers

 

    //   // Parent ticket info
    //   login_user_id: entry.login_user_id,
    //   login_user_email: entry.login_user_email,
    //   login_user_mobile: entry.login_user_mobile,
    //   ticket_no: entry.ticket_no,
    //   pnr_no: entry.pnr_no,
    //   source_name: entry.source_name,
    //   pickup_point_name: entry.pickup_point_name,
    //   depature_date: entry.depature_date,
    //   depature_time: entry.depature_time,
    //   destination_name: entry.destination_name,
    //   droping_point_name: entry.droping_point_name,
    //   arrival_date: entry.arrival_date,
    //   arraival_time: entry.arraival_time,
    //   operator_name: entry.operator_name,
    //   partialcancellation: entry.partialcancellation,
    //   cancel_date_time: entry.cancel_date_time,
    //   total_fare: entry.total_fare,
    //   refund_amt: entry.refund_amt,
    //   base_fare: entry.base_fare,
    //   gst: entry.gst,
    //   tbs_deal: entry.tbs_deal,
    //   tbs_discount: entry.tbs_discount,
    //   refund_percent: entry.refund_percent,
    //   device_type: entry.device_type,
    //   abhibus_refund: entry.abhibus_refund,
    //   offer_code: entry.offer_code,
    //   status_type: entry.status_type,
    //   payment_id: entry.payment_id,

    //   // Passenger-specific info
    //   // passenger_name: passenger.name,
    //   // passenger_age: passenger.age,
    //   // passenger_gender: passenger.gender,
    //   // passenger_seat: passenger.seat,
    //   // passenger_status: passenger.status,
    //   // passenger_tbs_fare: passenger.tbs_fare,
    //   // passenger_base_price: passenger.base_price,
    //   // passenger_total_fare: passenger.total_fare,
    //   // passenger_gst: passenger.gst,
    //   // passenger_tbs_deal: passenger.tbs_deal,
    //   // passenger_tbs_discount: passenger.tbs_discount
      
    // }))
  

  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(flattenedData);
  XLSX.utils.book_append_sheet(workbook, worksheet, "Ticket Data");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });
  const excelBlob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });
  saveAs(excelBlob, "ticket_data.xlsx");
};
const handleExport=()=>{
  if(dataArray){
    exportToExcel()
  }else if(dataArray2){
    exportToExcel2()
  }
}

  return (
    <button
      className={`bg-[#1F4B7F] shadow-sm shadow-black flex px-[0.75vw] text-white justify-center h-[5vh] gap-[0.5vw] items-center rounded-[0.5vw]  ${crud==="view"||crud==="create"||crud==="delete"?"cursor-not-allowed":"cursor-pointer"}`}
      // bg-[#1F4B7F] flex px-[1vw]  justify-center h-[5vh] gap-[0.5vw] items-center rounded-[0.5vw]
      onClick={()=>{
       if(crud!=="view"&&crud!=="create"&&crud!=="delete"){
        handleExport()
       }
      }}
    >
      <span>
        <CgExport size={"1.5vw"} color="white" />
      </span>
      {/* <span className="text-white font-bold text-[1.1vw] mt-[0.25vw]">Export</span> */}
    </button>
  );
};

export default ExportButton;
